export default "__VITE_ASSET___g7_V8oE__"